import {
    Badge,
    Card,
    Table,
    Container,
    Row,
    Breadcrumb,
    Col,
    Button,
    InputGroup,
    InputGroupText,
    CardBody,
    Spinner,
    DropdownMenu,
    DropdownItem,
    Media,
    UncontrolledDropdown,
    DropdownToggle,
    Dropdown,
    Input,
    Modal,
    BreadcrumbItem,
    ModalBody,
} from "reactstrap";
// core components
import ApiService from "constants/ApiService";
import { returnFirstDegreeObjValue } from "constants/utils";
import { showUtcDate } from "constants/utils";
import ToastList from "components/Toast/ToastList";
import { CustomListingContainer } from "components/Container/CustomListingContainer";
import { ListingHeaderLayout } from "components/Container/CustomListingContainer";
import { CustomSearch } from "components/FilterFields/Filterfields";
import { Button_without_Border } from "components/Buttons/Button";
import projectTimeline from "../../assets/img/brand/projectTimeline.svg";
import showMore from "../../assets/img/brand/showMore.svg";
import { showSuccess } from "constants/utils";
import closeIcon from "../../assets/img/icons/closeIcon.svg";
import { Custom_Button } from "components/Buttons/Button";
import { Component } from "react";
import { formatAmountWithCommas } from "constants/utils";
import ToolTip from "components/ToolTip/ToolTip";
import AddChangeOrder from "./addChangeOrder";
import timeLineSideBar from "views/Invoices/timeLineSideBar";
import TimeLine from "components/Timeline/Timeline";
import { returnSearchObject } from "constants/utils";
import { pushToFilteredPage } from "constants/utils";
import { remove_underscore_capitalize } from "constants/utils";
import ReactTooltip from "react-tooltip";
import CancelInvoiceModal from "views/Invoices/CancelInvoiceModal";
import PayMethod from "./projectDetails/payMethod";
import { isThisHour } from "date-fns/esm";
import MarkPaymentSideBar from "views/Invoices/MarkPaymentSideDragger";
import { showError } from "constants/utils";
import { filterQuery } from "constants/utils";
let ID;

class paymentList extends Component {
    constructor(props) {
        super(props);
        ID = this.props?.match?.params?.project_id
        this.state = {
            paymentList: [],
            isLoading: false,
            toast: "",
            response: "",
            toastType: "",
            input_value: false,
            inputSearch: "",
            total: 0,
            page: 1,
            ID: "",
            timeLine: {},
            timeLineOpen: false,
            filterOption: "",
            inputSearch: "",
            statusSearch: "",
            cancelModal: false,
            changeOrderId: "",
            paymentList: {},
            invoiceId: null,
            cancelInvoiceModal: false,
            openPaymentModal: false,
            invoiceAmount: ""
        };
    }
    componentDidMount = async () => {
        this.setQueryStatus()
    };
    setQueryStatus = () => {
        let queryStatus = this.props.location.search;
        let queryObj = returnSearchObject(queryStatus);
        if (queryStatus) {
            this.setState(
                {
                    // inputSearch: queryObj[this.returnCurrentFilterOption(queryObj)] ?? "",
                    // filterOption: queryObj.name ? "name" : "name",
                    statusSearch: queryObj.status ?? "",
                    page: parseInt(queryObj.page) ?? "",
                    query: returnSearchObject(queryStatus),
                },
                () => {
                    pushToFilteredPage(this.props, { ...this.state.query });
                    this.getpaymentList();
                }
            );
        } else {
            this.setState(
                {
                    query: {
                        ...queryObj,
                        page: 1,
                        limit: 10,
                    },
                },  
                () => {
                    // this.setStatus(queryObj.status);
                    pushToFilteredPage(this.props, { ...this.state.query });
                    this.getpaymentList();
                }
            );
        }
    };

    getpaymentList = async () => {
        let { filterOption, inputSearch, statusSearch } = this.state;
        let queryParams = "";
        if (filterOption !== "" && inputSearch !== "")
            queryParams += filterQuery(filterOption, inputSearch);
        if (statusSearch !== "") {
            queryParams += filterQuery("status", statusSearch);
        } else
        this.setState({ isLoading: true })
        let response = await ApiService.getAPI(`contractor/crmPayment/payments/${ID}`);
        this.setState({ isLoading: false })
        if (response.success) {
            this.setState({ paymentList: response.data.invoices })
        }
    }

    handleIncrementPage = () => {
        if (this.state.paymentList.length >= 10) {
            this.setState({ page: this.state.page + 1, input_value: true }
                , () => this.handleFilterStatus()
            );
        }
    };

    handleDecrementPage = () => {
        if (this.state.page > 1) {
            this.setState(
                {
                    page: this.state.page - 1,
                    input_value: this.state.page - 1 === 1 ? false : true,
                },
                () => this.handleFilterStatus()
            );
        } else this.setState({ input_value: false });
    };
    handleFilterStatus = () => {
        let staticQuery = returnSearchObject(this.props.location.search);
        staticQuery.status = this.state.statusSearch ?? "";
        staticQuery.page = this.state.page ?? "";
        if (this.state.inputSearch !== "" && this.state.filterOption !== "") {
            staticQuery[this.state.filterOption] = this.state.inputSearch;
        } else staticQuery[this.state.filterOption] = "";
        this.setState({ query: staticQuery }, () => {
            pushToFilteredPage(this.props, { ...this.state.query });
            this.getpaymentList();
        });
    };

    openCancelInvoicePopup = (id) => {
        this.setState({ cancelInvoiceModal: true, invoiceId: id })
    };
    toggleCancelInvoiceModal = (msg) => {
        this.setState({ cancelInvoiceModal: false, invoiceId: "" })
        if (msg) {
            showSuccess(this, msg);
            this.getpaymentList();
        }
    };
    onTimeLineClick = (obj, from) => {
        this.setState({
            timeLineOpen: true,
            timeLine: {
                ...this.state.timeLine,
                id: obj.invoice_id,
                from: from
            }
        })
    }
    closeTimeline = () => {
        this.setState({
            timeLineOpen: false,
            timeLine: {
                ...this.state.timeLine,
                id: "",
                from: ""
            }
        })
    }
    closeMarkPaymentSideDraggger = (msg) => {
        if (msg) {
            showSuccess(this, msg);
            this.getpaymentList();
        }
        this.setState({ markPaymentModal: false })
    };
    displayErrorMessage = (msg) => {
        if (msg) {
            showError(this, msg);
        }
    };
    render() {
        let {
            paymentList,
            isLoading,
            toast,
            response,
            toastType,
            page,
            cancelInvoiceModal,
            invoiceId,
            timeLineOpen,
            openPaymentModal,
            invoiceAmount,
            markPaymentModal,
        } = this.state;

        return isLoading ? (
            <div className="spin-loading">
                <Spinner type="border" color="#077e8b" />
            </div>
        ) : (
            <div
                style={{ height: "100vh", padding: "20px", backgroundColor: "#fafafa" }}
            >
                {toast && <ToastList message={response} type={toastType} />}
                <div
                    className="align-items-center"
                    style={{ paddingBottom: "20px" }}
                >
                    <div xs="8" className="manage-con">
                        <div>
                            <Breadcrumb className="">
                                <BreadcrumbItem onClick={() => {
                                    this.props.history.push({
                                        pathname: `/admin/projects/detail/${ID}`,
                                    })
                                }} className="bread-cursor">
                                    {"Project"}
                                </BreadcrumbItem>
                                <BreadcrumbItem
                                    style={{ color: "#72569c" }}
                                    className="bread-cursor"
                                >
                                    {"Payments"}
                                </BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                    </div>
                </div>
                <CustomListingContainer>
                    <ListingHeaderLayout label={"Payments"}
                    // primary_buttonLabel={"Add"}
                    // isPrimary
                    // click={() => this.openChangeOrders()}
                    />
                    {/* <div style={{ margin: "24px" }}>
                        <div
                            className="d_flex_sb"
                            style={{
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    width: "80%",
                                    justifyContent: "space-between",
                                }}
                            >
                                <CustomSearch
                                    options={filters}
                                    change={this.onChangeHandler}
                                    filterOption={filterOption}
                                    inputSearch={inputSearch}
                                    from="filterOption"
                                />
                            </div>
                            {(input_value && inputSearch) && (
                                <div className="right_filter_container">
                                    <Button_without_Border
                                        click={this.handleReset}
                                        btnLabel={"clear_filter"}
                                    ></Button_without_Border>
                                </div>
                            )}
                        </div>
                    </div> */}
                    <div>
                        <Row>
                            <div className="col new-table">
                                <Card className="shadow card_with_paginator">
                                    {paymentList &&
                                        paymentList?.length !== 0 ? (
                                        <Table
                                            className="align-items-center table-flush"
                                            responsive
                                        >
                                            <thead className="thead-light">
                                                <tr>
                                                    <th
                                                        style={{ paddingLeft: "25px", width: "20%" }}
                                                        scope="col"
                                                    >
                                                        ID
                                                    </th>
                                                    <th scope="col">Title</th>
                                                    <th scope="col">Created On</th>
                                                    <th scope="col">Due On</th>
                                                    <th scope="col">Amount</th>
                                                    <th scope="col">Status</th>
                                                    <th style={{ width: "6%" }} scope="col"></th>
                                                </tr>
                                            </thead>
                                            {paymentList.length > 0 && (
                                                <tbody>
                                                    {paymentList.map((order, i) => (
                                                        <tr key={i}>
                                                            <td className="text-capitalize">
                                                                {order.invoice_id}
                                                            </td>
                                                            <td
                                                                style={{ paddingLeft: "25px" }}
                                                                className="text-capitalize"
                                                            >
                                                                {order?.title}
                                                            </td>

                                                            <td className="">
                                                                {showUtcDate(order.createdAt)}
                                                            </td>
                                                            <td className="text-capitalize">
                                                                {showUtcDate(order.due)}
                                                            </td>
                                                            <td className="text-capitalize">
                                                                {"$" +
                                                                    formatAmountWithCommas(
                                                                        order.amount.toFixed(2)
                                                                    )}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    color: `${order.status === "processing"
                                                                        ? "#FF4949"
                                                                        : order.status === "paid"
                                                                            ? "#07A84E"
                                                                            : order.status === "created"
                                                                                ? "#FFCC3D"
                                                                                : "#FFCC3D"
                                                                        }`,
                                                                    fontWeight: "500",
                                                                }}
                                                                className="text-capitalize"
                                                            >
                                                                {remove_underscore_capitalize(
                                                                    order.status === "created"
                                                                        ? "unpaid"
                                                                        : order.status
                                                                )}
                                                            </td>
                                                            <td style={{ paddingLeft: "20px" }}>
                                                                <div
                                                                    style={{ gap: "20px" }}
                                                                    className="flexStart"
                                                                >
                                                                    <ToolTip label="Timeline">
                                                                        <img
                                                                            onClick={() =>
                                                                                this.onTimeLineClick(order, "payment")
                                                                            }
                                                                            className="point"
                                                                            src={projectTimeline}
                                                                            alt="timeline"
                                                                        />
                                                                    </ToolTip>
                                                                    {order.status === "created" ||
                                                                        order.status === "paid" ? (
                                                                        <UncontrolledDropdown
                                                                            nav
                                                                            className="flexy-content position_u"
                                                                        >
                                                                            <DropdownToggle
                                                                                className="pr-0 nav-notice"
                                                                                nav
                                                                            >
                                                                                <Media className="align-items-center">
                                                                                    <img src={showMore} />
                                                                                </Media>
                                                                            </DropdownToggle>
                                                                            <DropdownMenu
                                                                                className="dropdown-menu-arrow min-width-drop"
                                                                                right
                                                                            >
                                                                                {order.status === "created" && (
                                                                                    <>
                                                                                        <DropdownItem
                                                                                            onClick={() =>
                                                                                                this.openCancelInvoicePopup(
                                                                                                    order.invoice_id
                                                                                                )}
                                                                                        >
                                                                                            <span>Cancel</span>
                                                                                        </DropdownItem>
                                                                                        <DropdownItem
                                                                                            onClick={() => { this.setState({ markPaymentModal: true, invoiceId: order.invoice_id }) }}
                                                                                        >
                                                                                            <span>Mark Payment</span>
                                                                                        </DropdownItem>
                                                                                    </>
                                                                                )}
                                                                                <DropdownItem
                                                                                // onClick={() =>
                                                                                //   this.downloadInvoice(
                                                                                //     order.invoice_id
                                                                                //   )
                                                                                // }
                                                                                >
                                                                                    <span>Download Invoice</span>
                                                                                </DropdownItem>
                                                                            </DropdownMenu>
                                                                        </UncontrolledDropdown>
                                                                    ) : order.status === "cancelled" ? (
                                                                        <div
                                                                            data-tip={order?.cancel_reason}
                                                                            data-iscapture="true"
                                                                            data-for="toolTip1"
                                                                            data-place="top"
                                                                            className="new-border-request no_border mr-10 cladb5bd"
                                                                        >
                                                                            <i className="fa fa-info-circle verticalMidAlign"></i>
                                                                            <ReactTooltip
                                                                                place="top"
                                                                                type="info"
                                                                                effect="solid"
                                                                                id="toolTip1"
                                                                                html={true}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )}
                                        </Table>
                                    ) : (
                                        <>
                                            <Table
                                                className="align-items-center table-flush"
                                                responsive
                                            >
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th style={{ paddingLeft: "25px" }} scope="col">
                                                            ID
                                                        </th>
                                                        <th scope="col">Title</th>
                                                        <th scope="col">created On</th>
                                                        <th scope="col">Due On</th>
                                                        <th scope="col">Cost</th>
                                                        <th scope="col">Status</th>
                                                        <th style={{ width: "5%" }} scope="col"></th>
                                                    </tr>
                                                </thead>
                                            </Table>
                                            <Card className="card_with_paginator no_data_card">
                                                {" "}
                                                <div className="no-data">No Payments Available</div>
                                            </Card>
                                        </>
                                    )}
                                </Card>
                            </div>
                        </Row>
                        <Row className="align-items-center header-div jus-space new-margin-page paginator_box">
                            <div className="paginate-flex-box ">
                                <div
                                    className="paginate-box"
                                    onClick={() => this.handleDecrementPage()}
                                >
                                    <p
                                        className={
                                            page !== 1 ? "page_available" : "page_unavailable"
                                        }
                                    >
                                        Previous
                                    </p>
                                </div>
                                <div
                                    className="paginate-box"
                                    onClick={() => this.handleIncrementPage()}
                                >
                                    <p
                                        className={
                                            paymentList?.length < 10
                                                ? "page_unavailable"
                                                : "page_available"
                                        }
                                    >
                                        Next
                                    </p>
                                </div>
                            </div>
                        </Row>
                    </div>
                </CustomListingContainer>
                <Card className={timeLineOpen ? "exportSideBar" : "toggle-sidebar"}>
                    {timeLineOpen && (
                        <TimeLine
                            id={this.state.timeLine.id}
                            closeTimelineModal={this.closeTimeline}
                            from={this.state.timeLine.from}
                        ></TimeLine>
                    )}
                </Card>
                <Card
                    style={{ zIndex: "1000" }}
                    className={markPaymentModal ? "exportSideBar" : "toggle-sidebar"}
                >
                    {markPaymentModal && (
                        <MarkPaymentSideBar
                            close={this.closeMarkPaymentSideDraggger}
                            isOpen={markPaymentModal}
                            toast={this.displayErrorMessage}
                            id={invoiceId}
                        />
                    )}
                </Card>
                <Modal
                    isOpen={cancelInvoiceModal}
                    toggle={() => this.toggleCancelInvoiceModal()}
                    centered
                >
                    <CancelInvoiceModal close={this.toggleCancelInvoiceModal} id={invoiceId} />
                </Modal>
                <Modal
                    isOpen={openPaymentModal}
                    centered={true}
                    style={{ minWidth: "650px", padding: "2rem" }}
                >
                    {openPaymentModal && (
                        <PayMethod
                            // props={this.props}
                            invoice_id={invoiceId}
                            close={() => { this.setState({ openPaymentModal: false }); }}
                            amount={invoiceAmount}
                        />
                    )}
                </Modal>
            </div>
        );
    }
}

export default paymentList;
